var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.5H6C4.89543 7.5 4 8.39543 4 9.5V18.5C4 19.6046 4.89543 20.5 6 20.5H15C16.1046 20.5 17 19.6046 17 18.5V15.5",
    stroke: "#4B465C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.5H6C4.89543 7.5 4 8.39543 4 9.5V18.5C4 19.6046 4.89543 20.5 6 20.5H15C16.1046 20.5 17 19.6046 17 18.5V15.5",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.5H12L20.5 6.99998C21.3284 6.17156 21.3284 4.82841 20.5 3.99998C19.6716 3.17156 18.3284 3.17156 17.5 3.99998L9 12.5V15.5",
    stroke: "#4B465C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.5H12L20.5 6.99998C21.3284 6.17156 21.3284 4.82841 20.5 3.99998C19.6716 3.17156 18.3284 3.17156 17.5 3.99998L9 12.5V15.5",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.5L19 8.5",
    stroke: "#4B465C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.5L19 8.5",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.22cc0978cee1ae12ee31fc8a716f4403.svg";
export { ForwardRef as ReactComponent };